<template>
<div class="wall-content" :style="{'height': height + 'px'}">
  <div v-for="(photo, index) in photos" :key="index" class="photo-item">
    <img :src="photo.photoUrl || ''" @click="onPreviewClick(photo.photoUrl)"/>
    <span>{{photo.photoName || ''}}</span>
    <Icon type="ios-close-circle" @click="onDeleteClick(photo)"/>
  </div>
  <Spin size="large" fix  v-if="loading"></Spin>
  <Modal title="预览" v-model="preview.show" :footer-hide="true" fullscreen>
    <div class="preview-con">
        <img :src="preview.url" @click="preview.show = false">
    </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: 'photoWallCom',
  props: {
    photos: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      default: 100
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      preview: {
        url: '',
        show: false
      }
    }
  },
  methods: {
    onDeleteClick (photo) {
      this.$Modal.confirm({
        content: `<div class="tip_text"><i class="iconfont icon-tishi"></i><p>是否确认删除图片 ${photo.photoName} ？</p></div>`,
        onOk: () => {
          this.$emit('delete', photo)
        },
        onCancel: () => {

        }
      })
    },
    onPreviewClick (url) {
      if (!url) return
      this.preview.url = url
      this.preview.show = true
    }
  }
}
</script>
<style scoped>
.wall-content{
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}
.photo-item{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin: 0 20px 20px 0;
}
.wall-content img{
  width: 300px;
  height: 200px
}
.wall-content i{
   position: absolute;
   font-size: 28px;
   top: -14px;
   right: -14px;
   display: none;
   color:Silver;
}
.wall-content div:hover i{
   display: block;
}
.wall-content span{
  font-size: 16px;
  display: inline-block;
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.preview-con{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/photo-wall.vue